var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M264.722,206.079c-29.736,0-53.93,24.192-53.93,53.93c0,29.737,24.192,53.93,53.93,53.93 c29.737,0,53.93-24.192,53.93-53.93C318.652,230.271,294.46,206.079,264.722,206.079z M264.722,298.151 c-21.03,0-38.141-17.11-38.141-38.141s17.109-38.141,38.141-38.141c21.031,0,38.141,17.11,38.141,38.141 S285.753,298.151,264.722,298.151z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M132.711,340.106c10.313,1.926,21.121,3.622,32.126,5.042l2.02-15.66c-10.711-1.382-21.225-3.032-31.247-4.902 L132.711,340.106z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M71.194,212.839l-5.62-14.756C54.16,202.431,44,207.193,35.376,212.239l7.974,13.628 C51.225,221.261,60.593,216.877,71.194,212.839z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M257.81,185.045l0.042-15.789l-2.338-0.003c-10.053,0.001-20.171,0.201-30.073,0.594l0.627,15.777 c9.695-0.385,19.602-0.581,29.447-0.582L257.81,185.045z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M255.516,350.767c2.138,0,4.27-0.009,6.396-0.026l-0.132-15.789c-10.52,0.091-21.249-0.047-31.736-0.408l-0.099,2.887 l-8.3,8.717c7.878,7.501,15.942,14.849,23.969,21.844l10.372-11.906c-2.018-1.758-4.039-3.541-6.059-5.342 C251.792,350.757,253.656,350.767,255.516,350.767z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M354.902,176.058c-10.459-1.502-21.313-2.775-32.263-3.784l-1.448,15.724c10.685,0.984,21.271,2.225,31.468,3.689 L354.902,176.058z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M31.02,234.217l-9.837-12.351C9.596,231.092,2.469,241.123,0,251.68l15.373,3.596 C17.015,248.263,22.279,241.178,31.02,234.217z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M274.065,169.476l-0.384,15.785c6.71,0.163,13.423,0.43,20.08,0.776c0.475,0.421,0.954,0.836,1.427,1.259l1.012-1.133 c3.077,0.17,6.143,0.354,9.182,0.562l1.08-15.752c-2.109-0.145-4.236-0.274-6.364-0.4c-6.338-5.538-12.736-10.936-19.093-16.097 l-9.951,12.259c1.114,0.903,2.23,1.832,3.345,2.749C274.287,169.484,274.177,169.478,274.065,169.476z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M15.94,266.74l-14.984,4.978c3.335,10.041,10.968,19.574,22.689,28.334l9.451-12.648 C24.011,280.614,18.239,273.661,15.94,266.74z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M278.119,350.432c10.875-0.324,21.772-0.888,32.391-1.678l-1.171-15.746c-10.387,0.773-21.049,1.325-31.689,1.641 L278.119,350.432z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M449.907,199.824c-9.454-3.799-19.943-7.343-31.175-10.53l-4.312,15.189c10.701,3.038,20.659,6.399,29.599,9.991 L449.907,199.824z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M402.906,185.151c-10.124-2.441-20.868-4.646-31.934-6.557l-2.685,15.559c10.726,1.852,21.129,3.986,30.92,6.346 L402.906,185.151z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M160.778,175.409c-11.014,1.495-21.817,3.269-32.107,5.277l3.021,15.498c9.995-1.948,20.496-3.674,31.21-5.128 L160.778,175.409z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M505.612,238.904l-13.402,8.349c2.655,4.261,4,8.552,4,12.757c0,3.293-0.824,6.645-2.448,9.966l14.184,6.939 c2.69-5.5,4.055-11.187,4.055-16.905C512,252.809,509.851,245.709,505.612,238.904z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M461.542,297.541l7.307,13.997c11.665-6.09,21.125-12.72,28.115-19.705l-11.161-11.169 C479.949,286.514,471.785,292.193,461.542,297.541z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M493.726,225.13c-7.369-6.577-16.998-12.818-28.617-18.547l-6.984,14.161c10.34,5.1,18.781,10.539,25.087,16.166 L493.726,225.13z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M403.029,318.578c-9.748,2.447-20.127,4.669-30.85,6.602l2.801,15.539c11.071-1.996,21.802-4.293,31.894-6.826 L403.029,318.578z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M178.625,189.129c10.292-1.127,20.922-2.037,31.595-2.699l-0.979-15.759c-10.92,0.679-21.8,1.607-32.338,2.763 L178.625,189.129z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M326.682,347.36c10.966-1.078,21.815-2.421,32.244-3.992l-2.351-15.612c-10.162,1.529-20.74,2.839-31.438,3.891 L326.682,347.36z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M447.604,304.068c-6.997,2.953-14.676,5.755-22.884,8.366c-3.464-5.418-7.1-10.894-10.921-16.387l-12.962,9.015 c6.222,8.946,11.997,17.851,17.164,26.467l4.453-2.67l0.215,0.726c11.255-3.328,21.709-7.019,31.074-10.969L447.604,304.068z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M325.464,215.919c1.403,1.402,2.797,2.807,4.181,4.214l11.251-11.077c-1.413-1.435-2.836-2.869-4.268-4.302 c-6.226-6.225-12.602-12.385-18.953-18.309l-10.769,11.546C313.124,203.791,319.368,209.822,325.464,215.919z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M404.315,282.829c-6.266-8.478-12.992-17.093-19.99-25.607l-12.198,10.024c6.826,8.307,13.384,16.707,19.49,24.968 L404.315,282.829z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M258.632,156.908l9.638-12.506c-8.789-6.775-17.636-13.212-26.293-19.136l-8.917,13.03 C241.473,144.055,250.077,150.315,258.632,156.908z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.873,244.807c-6.95-8.06-14.26-16.162-21.727-24.079l-11.486,10.833c7.307,7.748,14.459,15.674,21.255,23.557 L373.873,244.807z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M219.444,321.941c-6.927-6.927-13.766-14.041-20.326-21.141l-11.598,10.716c6.701,7.253,13.684,14.516,20.761,21.592 l0.377,0.375c-8.789-0.565-17.537-1.286-26.069-2.167l-1.622,15.705c10.568,1.092,21.448,1.956,32.341,2.57l0.889-15.765 c-0.992-0.056-1.981-0.124-2.972-0.185l9.928-9.999L219.444,321.941z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M382.979,454.944c12.278,4.16,23.504,6.546,33.366,7.091l0.873-15.765c-8.434-0.466-18.249-2.58-29.172-6.282 L382.979,454.944z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M453.923,367.314c-3.842-9.408-8.637-19.401-14.248-29.702l-13.865,7.554c5.333,9.79,9.874,19.25,13.496,28.119 L453.923,367.314z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M337.955,434.396c10.2,5.686,20.123,10.594,29.492,14.586l6.189-14.525c-8.86-3.776-18.278-8.437-27.994-13.852 L337.955,434.396z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M449.897,416.852l15.789-0.088c-0.056-9.882-2.095-21.247-6.058-33.777l-15.055,4.761 C448.059,398.766,449.849,408.559,449.897,416.852z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M296.615,408.204c9.176,6.473,18.333,12.508,27.219,17.937l8.233-13.472c-8.591-5.249-17.457-11.093-26.35-17.367 L296.615,408.204z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M107.801,94.768c6.465-3.246,15.618-4.095,26.753-2.484l2.259-15.627c-14.452-2.089-26.66-0.737-36.095,4L107.801,94.768 z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M442.65,439.127c-2.951,2.951-6.901,5.025-11.742,6.166l3.622,15.368c7.74-1.824,14.228-5.314,19.284-10.37 c4.127-4.128,7.226-9.236,9.208-15.182l-14.979-4.994C446.845,433.715,445.03,436.747,442.65,439.127z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M95.488,128.563c-0.317-2.755-0.478-5.409-0.478-7.887c0-7.469,1.435-13.579,4.263-18.161l-13.435-8.296 c-4.392,7.113-6.619,16.013-6.619,26.457c0,3.079,0.196,6.339,0.58,9.69L95.488,128.563z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M98.325,143.187l-15.27,4.014c2.541,9.668,6.364,20.216,11.365,31.349l14.404-6.468 C104.178,161.737,100.645,152.017,98.325,143.187z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M85.933,207.698c6.395-2.042,13.169-3.976,20.222-5.782c3.583,6.495,7.496,13.142,11.704,19.862l13.381-8.382 c-5.842-9.327-11.099-18.5-15.623-27.262l-2.168,1.119l-0.733-3.184c-11.149,2.566-21.778,5.456-31.588,8.588L85.933,207.698z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M257.972,378.507c8.466,7.035,17.042,13.807,25.49,20.131l9.461-12.642c-8.236-6.163-16.6-12.769-24.861-19.633 L257.972,378.507z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M168.046,264.785l-12.314,9.883c6.635,8.267,13.672,16.616,20.917,24.815l11.832-10.455 C181.401,281.014,174.526,272.857,168.046,264.785z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M158.289,252.308c-6.545-8.596-12.751-17.239-18.446-25.688l-13.092,8.826c5.864,8.7,12.249,17.591,18.977,26.427 L158.289,252.308z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M172.459,110.16c0,8.535,3.323,16.558,9.359,22.594c6.228,6.228,14.411,9.343,22.593,9.343s16.364-3.115,22.593-9.343 v-0.001c12.457-12.459,12.457-32.729,0-45.186c-6.035-6.036-14.059-9.36-22.593-9.36c-8.535,0-16.559,3.323-22.593,9.359 c-0.737,0.736-1.43,1.503-2.085,2.296c-9.232-4.037-18.041-7.259-26.241-9.579l-4.299,15.193 c7.401,2.094,15.401,5.018,23.831,8.687C172.653,106.121,172.459,108.125,172.459,110.16z M192.982,98.732 c3.053-3.052,7.111-4.734,11.428-4.734c4.317,0,8.376,1.682,11.428,4.735c6.301,6.301,6.301,16.556,0,22.857 c-6.302,6.303-16.557,6.3-22.858,0.001c-3.053-3.053-4.734-7.112-4.734-11.429C188.247,105.844,189.929,101.785,192.982,98.732z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39,
    y: 396.459,
    width: 16.038,
    height: 15.789
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 87.115,
    y: 452.595,
    width: 16.038,
    height: 15.789
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 191.366,
    y: 412.49,
    width: 16.038,
    height: 15.789
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 263.534,
    y: 476.647,
    width: 16.038,
    height: 15.789
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 431.932,
    y: 131.83,
    width: 16.038,
    height: 15.789
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 415.9,
    y: 228.061,
    width: 16.038,
    height: 15.789
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 79.094,
    y: 244.092,
    width: 16.038,
    height: 15.789
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 30.983,
    y: 139.851,
    width: 16.038,
    height: 15.789
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 95.136,
    y: 19.563,
    width: 16.038,
    height: 15.789
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 30.983,
    y: 51.642,
    width: 16.038,
    height: 15.789
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 335.701,
    y: 51.642,
    width: 16.038,
    height: 15.789
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 472.026,
    y: 19.563,
    width: 16.038,
    height: 15.789
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 423.911,
    y: 59.659,
    width: 16.038,
    height: 15.789
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 223.439,
    y: 19.563,
    width: 16.038,
    height: 15.789
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 295.607,
    y: 107.778,
    width: 16.038,
    height: 15.789
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 464.005,
    y: 476.647,
    width: 16.038,
    height: 15.789
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M95.135,292.211c-10.969,0-20.663,5.558-26.42,14.004c-8.56-3.365-16.29-6.958-23.01-10.715l-7.702,13.783 c7.443,4.16,15.951,8.111,25.333,11.783c-0.099,1.02-0.153,2.052-0.153,3.096c0,17.618,14.334,31.951,31.951,31.951 s31.951-14.333,31.951-31.951S112.753,292.211,95.135,292.211z M95.135,340.325c-8.911,0-16.162-7.25-16.162-16.162 c0-8.911,7.25-16.162,16.162-16.162c8.911,0,16.162,7.25,16.162,16.162C111.297,333.074,104.047,340.325,95.135,340.325z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b6e3a1e60dbf48cf1025bed6f90185d3.svg";
export { ForwardRef as ReactComponent };